import { js_utils } from "../utils/frfr-js-utils";
import { _virbom_bidirectional_traversing_update } from "../utils/frfr-virbom-bidirectional-traversing-utils";


// VREMENA I MASA I CENA


/*
- DILEMA: Vreme kumulativno moze da se racuna i pomocu metoda sa kolicinom po jedinici sledece operaicja i sa metodom kolicina_za_nalog. U oba metoda konacno kumulativno vreme na vrhu sastavnice bude isto. Medjutim razlika je sta bude u redovima koji su hijerarhijski nizi. 
Za sada smo se odlucili za resenje sa metodom kolicina_za_nalog jer u nizim redovima prikazuje vece cifre koje su inoformativnije jer korisnik koji gleda te podatke moze prostijim sabiranjem (ne mora nista da mnozi) da dodje do konacnih cifara.

- Sledeca problematika je kako da se tretira vreme_ugradnje_u_parent?
Deluje da je logicno da se tokom kolektovanja tih podataka svaki children za sebe to mora da pomnozi sa kolicina_za_nalog jer nakon kolektovanja/sabiranja niko vise ne moze da rasclani te podatke da bi znao da ih pomnozi sa kojom kolicinom.

- PROBLEMATIKA MASE
Masa poreklom dolazi samo od materijala i moze se u pojedinim operacijam stvoriti uvecanja ili smanjenje mase.
TODO mogunosti uvecanja mase po operaciji cemo naknadno resavati...
Za sada smo se odlucili da, slično kao kod vremena, da se koristi metoda kolicina_za_nalog. Masa se u samom elementu mnozi sa kolicinom za nalog a dalje se prosledjuje perentu gde se sam osabira kao masa_kumulativna.
*/


export const _dopuni_virbom_seq_sa_kumulativnim_vremenima = (virbom_seq, _cb_extract_masa_po_jm_from_virtel, _cb_extract_cena_po_jm_from_virtel) => {
  console.log('***** VREMENA RACUNANJE i update virbom_seq sa vremenima');

  const _own_data_creator = (virtel, parent_data) => {
    const own_data = {
      // kolicina: 0,
      kolicina_za_nalog: 0,
      vreme_operacije: 0,
      vreme_ugradnje_u_parent: 0,
      //
      masa_po_jm: 0,
      // masa_uvecanje: 0, // TODO
      //
      cena_po_jm: 0,
    };
    /*
    if (js_utils.is_number(virtel.kolicina) && virtel.kolicina > 0) {
      own_data.kolicina = virtel.kolicina; // 2023-10-01
    }
    */
    if (js_utils.is_number(virtel.kolicina_za_nalog) && virtel.kolicina_za_nalog > 0) {
      own_data.kolicina_za_nalog = virtel.kolicina_za_nalog;
    }
    if (js_utils.is_number(virtel.vremeoperacije) && virtel.vremeoperacije > 0) {
      own_data.vreme_operacije = virtel.vremeoperacije;
    }
    if (js_utils.is_number(virtel.vremeugradnje) && virtel.vremeugradnje > 0) {
      own_data.vreme_ugradnje_u_parent = virtel.vremeugradnje;
    }
    //
    if (typeof _cb_extract_masa_po_jm_from_virtel === 'function') {
      const _extracted_masa_po_jm = _cb_extract_masa_po_jm_from_virtel(virtel);
      if (js_utils.is_number(_extracted_masa_po_jm) && _extracted_masa_po_jm > 0) {
        own_data.masa_po_jm = _extracted_masa_po_jm;
      }
    }
    /*
    if (js_utils.is_number(virtel.masa_uvecanje) && (virtel.masa_uvecanje > 0 || virtel.masa_uvecanje < 0)) {
      own_data.masa_uvecanje = virtel.masa_uvecanje;
    }
    */
    //
    if (typeof _cb_extract_cena_po_jm_from_virtel === 'function') {
      const _extracted_cena_po_jm = _cb_extract_cena_po_jm_from_virtel(virtel);
      if (js_utils.is_number(_extracted_cena_po_jm) && _extracted_cena_po_jm > 0) {
        own_data.cena_po_jm = _extracted_cena_po_jm;
      }
    }
    //
    return own_data;
  };


  const _make_new_obj_children_collected_data = () => {
    const children_collected_data = {
      vreme_kumulativno: 0,
      vreme_ugradnje_u_parent: 0,
      //
      masa_kumulativno: 0,
      cena_kumulativno: 0,
    };
    return children_collected_data;
  };


  const _collector = (child_data, ref_children_collected_data) => {
    // every child will merge self data with their sibling data
    //
    ref_children_collected_data.vreme_kumulativno += child_data.vreme_kumulativno;
    //
    if (child_data.vreme_ugradnje_u_parent > 0) {
      // SAMO SABIRANJE KUMULATIVNIH VREDNOSTI jer su ovi podaci vec pomnozeni sa kolicina_za-nalog u samom childu
      ref_children_collected_data.vreme_ugradnje_u_parent += child_data.vreme_ugradnje_u_parent;
    }
    //
    if (child_data.masa_kumulativno > 0) {
      // SAMO SABIRANJE KUMULATIVNIH VREDNOSTI jer su ovi podaci vec pomnozeni sa kolicina_za-nalog u samom childu // TODO
      ref_children_collected_data.masa_kumulativno += child_data.masa_kumulativno;
    }
    //
    if (child_data.cena_kumulativno > 0) {
      // SAMO SABIRANJE KUMULATIVNIH VREDNOSTI jer su ovi podaci vec pomnozeni sa kolicina_za-nalog u samom childu // TODO
      ref_children_collected_data.cena_kumulativno += child_data.cena_kumulativno;
    }
    //
    return ref_children_collected_data;
  };


  const _combine_own_and_children_collected_data = (own_data, children_collected_data) => {
    // console.log('* children_collected_data');
    // console.log(children_collected_data);
    const combined_data = {
      vreme_kumulativno: 0,
      vreme_ugradnje_u_parent: 0,
      vreme_ugradnje_od_children: 0,
      //
      masa_kumulativno: 0,
      masa_po_jm: 0,
      //
      cena_kumulativno: 0,
      cena_po_jm: 0,
    };
    // combined_data.vreme_kumulativno = (own_data.vreme_operacije + children_collected_data.vreme_ugradnje_u_parent + children_collected_data.vreme_kumulativno) * own_data.kolicina;
    const _own_vreme_operacije = ((own_data.vreme_operacije) * own_data.kolicina_za_nalog); // MNOZENJE
    combined_data.vreme_kumulativno = _own_vreme_operacije + children_collected_data.vreme_ugradnje_u_parent + children_collected_data.vreme_kumulativno; // SAMO SABIRANJE // 2023-10-01 ispravljeno da se vreme_kumulativno od children ne mnozi ni sa cim nego da se samo sabira.
    // combined_data.vreme_ugradnje_u_parent = own_data.vreme_ugradnje_u_parent * own_data.kolicina;
    combined_data.vreme_ugradnje_u_parent = own_data.vreme_ugradnje_u_parent * own_data.kolicina_za_nalog; // MNOZENJE // 2023-10-01 kolicina_za_nalog se koristi jer je nemoguce da neko od parent elementa zna koliko puta se koji children pojavljuje
    combined_data.vreme_ugradnje_od_children = children_collected_data.vreme_ugradnje_u_parent; // SAMO PROSLEDJIVANJE PARENTU
    //
    const _own_masa = (own_data.masa_po_jm * own_data.kolicina_za_nalog); // MNOZENJE
    combined_data.masa_kumulativno = _own_masa + children_collected_data.masa_kumulativno; // SAMO SABIRANJE // ???
    if (own_data.masa_po_jm > 0) {
      combined_data.masa_po_jm = own_data.masa_po_jm;
    }
    //
    const _own_cena = (own_data.cena_po_jm * own_data.kolicina_za_nalog); // MNOZENJE
    combined_data.cena_kumulativno = _own_cena + children_collected_data.cena_kumulativno; // SAMO SABIRANJE // ???
    if (own_data.cena_po_jm > 0) {
      combined_data.cena_po_jm = own_data.cena_po_jm;
    }
    //
    return combined_data;
  };


  const _virtel_updater = (virtel, combined_data) => {
    const updated_virtel = { ...virtel };
    updated_virtel.vremekumulativno = combined_data.vreme_kumulativno;
    if (updated_virtel.operacija === 'OPSKL' || updated_virtel.operacija === 'OP-Sklapanje') {
      // operacija: 'OP-Sklapanje',
      const VREME_OP_SKLAPANJE = combined_data.vreme_ugradnje_od_children;
      if (VREME_OP_SKLAPANJE > 0) {
        updated_virtel.vremeopsklapanje = VREME_OP_SKLAPANJE; // vreme operacija sklapanje se samo upisuje u virtel radi prikaza u sastavnici ali je to vreme vec uracunato
      }
    }
    //
    updated_virtel.masa_kumulativno = combined_data.masa_kumulativno;
    if (updated_virtel.masa_po_jm > 0) {
      // preserve original value // TODO
      // do nothing
    } else {
      if (combined_data.masa_po_jm > 0) {
        updated_virtel.masa_po_jm = combined_data.masa_po_jm;
      } else {
        // do nothing
      }
    }
    //
    updated_virtel.cena_kumulativno = combined_data.cena_kumulativno;
    if (updated_virtel.cena_po_jm > 0) {
      // preserve original value // TODO
      // do nothing
    } else {
      if (combined_data.cena_po_jm > 0) {
        updated_virtel.cena_po_jm = combined_data.cena_po_jm;
      } else {
        // do nothing
      }
    }
    //
    return updated_virtel;
  };


  // EXECUTE
  return _virbom_bidirectional_traversing_update(virbom_seq, _own_data_creator, _make_new_obj_children_collected_data, _collector, _combine_own_and_children_collected_data, _virtel_updater);
};

